import { produce } from "immer";
import {
  FETCH_NOTIFICATION,
  FETCH_NOTIFICATION_SUCCESS,
  FETCH_NOTIFICATION_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_NOTIFICATION,
  ADD_NOTIFICATION_SUCCESS,
  ADD_NOTIFICATION_FAILURE,
  //
  EDIT_NOTIFICATION,
  EDIT_NOTIFICATION_SUCCESS,
  EDIT_NOTIFICATION_FAILURE,
  //
  DELETE_NOTIFICATION,
  DELETE_NOTIFICATION_SUCCESS,
  DELETE_NOTIFICATION_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingNotification: false,
  notification: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentNotification: {},
  // Delete
  isDeleting: false,
};

const NotificationReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_NOTIFICATION:
        draft.isFetchingNotification = true;
        break;
      case FETCH_NOTIFICATION_SUCCESS:
        draft.isFetchingNotification = false;
        draft.notification = action.payload;
        break;
      case FETCH_NOTIFICATION_FAILURE:
        draft.isFetchingNotification = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentNotification = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentNotification = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_NOTIFICATION:
        draft.isSubmitting = true;
        break;
      case ADD_NOTIFICATION_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_NOTIFICATION_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_NOTIFICATION:
        draft.isSubmitting = true;
        break;
      case EDIT_NOTIFICATION_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_NOTIFICATION_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_NOTIFICATION:
        draft.isDeleting = true;
        break;
      case DELETE_NOTIFICATION_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_NOTIFICATION_FAILURE:
        draft.isDeleting = false;
        break;

      default:
        return state;
    }
  });

export default NotificationReducer;
